<template>
    <div class='flex flex-col items-center relative'>
        <h5 class=" blue-text font-semibold">
            End Date
        </h5>
        <p
            class="font-normal blue-text cursor-pointer"
            @click="toggleSelectDate"
        >
            {{ date ? date : 'Select date'}}
        </p>
        <div
            v-show="purchasingData.endDate.open"
            class="calendar absolute left-auto right-0 sm:right-auto"
        >
            <v-date-picker
                v-model="date"
                :model-config="dateModelConfig"
            />
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import _ from "lodash";

export default {
    name: "PurchasingBarEndDate",

    data() {
        return {
            date: null,
            dateModelConfig: {
                type: 'string',
                mask: 'MM/DD/YYYY',
            }
        }
    },

    computed: {
        ...mapGetters({
            purchasingData: 'getPurchasingData',
        })
    },

    watch: {
        date(value) {
            if (value) {
                let purchasingData = _.cloneDeep(this.purchasingData);
                purchasingData.endDate.value = value;

                this.$store.dispatch('setPurchasingDestination', purchasingData);
            }

            this.toggleSelectDate();
        }
    },

    methods:{
        toggleSelectDate() {
            let purchasingData = _.cloneDeep(this.purchasingData);
            purchasingData.destination.open = false;
            purchasingData.startDate.open = false;
            purchasingData.endDate.open = !purchasingData.endDate.open;

            this.$store.dispatch('setPurchasingDestination', purchasingData);
        },
    }
}
</script>

<style lang="scss">
.payment-bar {
    &__end-date {
        max-width: 150px;

        .calendar {
            top: 4.5rem;
        }
    }
}
</style>